import { useEffect } from "react";
import { getTasks } from "../services/api-server/tasks";
import { useTaskStore } from "../stores/taskStore";
import { TTaskData } from "../types/task";

const getTaskIdFromPath = (pathname: string): string | null => {
	const match = pathname.match(
		/^\/projects\/([^/]+)\/([^/]+)\/([^/]+)\/([^/]+)/
	);
	return match ? match[4] : null;
};

function useInitTask(currentTenantKey: string | null) {
	const { task, setTask } = useTaskStore();
	const taskId = getTaskIdFromPath(location.pathname);

	useEffect(() => {
		if (!currentTenantKey) return;
		if (!taskId) {
			setTask({} as TTaskData);
			return;
		}
		if (!task || task._id !== taskId) {
			getTasks(currentTenantKey, {
				_id: taskId,
			}).then((task: any) => {
				setTask(task[0]);
			});
		}
	}, [taskId, currentTenantKey]);
}

export default useInitTask;
